module.exports = __webpack_public_path__ + "static/media/marina_m.f59ef640.jpg";